module.exports = __webpack_public_path__ + "img/maxim.7c1ae13c.png";